var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 40h14l32-18v56L32 60H18a4 4 0 0 1-4-4V44a4 4 0 0 1 4-4z",
    fill: "#e25569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62l6 20h10l-6-20z",
    fill: "#e25569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 38a16 16 0 0 1 0 24",
    stroke: "#e25569",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28a30 30 0 0 1 0 44",
    stroke: "#e25569",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.7dba3e298ff18ef2418a583877567b98.svg";
export { ForwardRef as ReactComponent };